import history from "./history";
import historyen from "./historyen";
export default{
    history,
    historyen
}